import gql from 'graphql-tag';

export default gql`
mutation updateTeam($obj: updateTeamInput!) {
  updateTeam(object: $obj) {
    updatedTeam
  }
}
`;
